import * as React from 'react';

const gradients: Record<string, string[]> = {
  blue: ['var(--blue-300)', 'var(--blue-500)'],
  navy: ['var(--navy-400)', 'var(--navy-500)'],
  aqua: ['var(--aqua-300)', 'var(--aqua-500)'],
  indigo: ['var(--indigo-300)', 'var(--indigo-500)'],
  purple: ['var(--purple-300)', 'var(--purple-500)'],
  yellow: ['var(--yellow-300)', 'var(--yellow-500)'],
  red: ['var(--red-300)', 'var(--red-500)'],
  green: ['var(--green-300)', 'var(--green-500)'],
  gray: ['var(--gray-400)', 'var(--gray-500)'],
  azure: ['var(--blue-300)', 'var(--blue-500)'],
  orchid: ['var(--indigo-400)', 'var(--purple-400)'],
  malibu: ['var(--purple-300)', 'var(--red-300)'],
  tropic: ['var(--blue-200)', 'var(--green-300)'],
  sky: ['var(--aqua-500)', 'var(--aqua-300)'],
  midnight: ['var(--navy-500)', 'var(--navy-300)'],
  black: ['var(--gray-600)', 'var(--gray-900)'],
  silver: ['var(--gray-200)', 'var(--gray-400)'],
  ice: ['var(--gray-0)', 'var(--gray-200)'],
  x: ['var(--purple-500)', 'var(--indigo-500)'],
  royale: ['var(--facebook)', 'var(--indigo-400)'],
  metal: ['var(--gray-400)', 'var(--gray-600)'],
};

interface GradientDefProps {
  gradient: string;
  start: string;
  stop: string;
}

const GradientDef: React.FC<GradientDefProps> = ({ gradient, start, stop }) => {
  return (
    <>
      <linearGradient
        id={`gradient-br-${gradient}`}
        key={`${gradient}-br`}
        x1="0%"
        x2="100%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor={start}></stop>
        <stop offset="100%" stopColor={stop}></stop>
      </linearGradient>
      <linearGradient
        id={`gradient-b-${gradient}`}
        key={`${gradient}-b`}
        x2="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor={start}></stop>
        <stop offset="100%" stopColor={stop}></stop>
      </linearGradient>
      <linearGradient
        id={`gradient-tl-${gradient}`}
        key={`${gradient}-tl`}
        x1="0%"
        x2="100%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor={stop}></stop>
        <stop offset="100%" stopColor={start}></stop>
      </linearGradient>
      <linearGradient
        id={`gradient-t-${gradient}`}
        key={`${gradient}-t`}
        x2="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor={stop}></stop>
        <stop offset="100%" stopColor={start}></stop>
      </linearGradient>
    </>
  );
};

export const CKIconGradient: React.FC = () => (
  <svg
    style={{
      position: 'absolute',
      width: 0,
      height: 0,
      visibility: 'hidden',
    }}
  >
    <defs>
      {Object.keys(gradients).map((gradient: string) => {
        const [start, stop] = gradients[gradient];

        return (
          <GradientDef
            gradient={gradient}
            key={gradient}
            start={start}
            stop={stop}
          />
        );
      })}
    </defs>
  </svg>
);
